<template>
  <vue-slider
    ref="slider"
    v-model="value"
    v-bind="options"
    class="ds-vue-slider"
  />
</template>

<script>
import vueSlider from "vue-slider-component";

export default {
  name: "DsSlider",
  components: {
    vueSlider
  },
  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      value: 0
    };
  },
  watch: {
    value(v) {
      this.$emit("input", v);
    }
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-slider.vue